import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">关于我们</h2>
          <p className="text-foreground-600 text-sm md:text-base">了解今日吃瓜的故事</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="p-6 md:p-8 rounded-2xl bg-background-100 border border-background-200/70">
            <div className="flex items-center gap-3 mb-5">
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-500 text-white text-base">🍉</span>
              <div>
                <h3 className="text-lg font-heading text-foreground-900">{aboutData.title}</h3>
                <p className="text-xs text-foreground-500">娱乐资讯与热点话题聚合平台</p>
              </div>
            </div>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-6">
              {aboutData.content}
            </p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {aboutData.stats.map((stat) => (
                <div key={stat.label} className="text-center p-4 rounded-xl bg-background-50 border border-background-200/60">
                  <span className="block w-9 h-9 mx-auto mb-2 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className={stat.icon}></i>
                  </span>
                  <p className="text-xl md:text-2xl font-heading text-primary-600">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}